export default "__VITE_ASSET__6mn4VyW5__"